<script setup lang="ts">
const props = defineProps<{
  videoInformation: VideoInformation
}>()

const playerVars = {
  autoplay: 1,
  modestbranding: 1,
  showinfo: 0,
  loop: 0,
  playsinline: 1,
  fs: 0,
  controls: 1,
}
</script>

<template>
  <ScriptYouTubePlayer :video-id="props.videoInformation.id" above-the-fold trigger="immediate" :player-vars="playerVars" :width="1920" :height="1080" />
</template>
